import { Component } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { TranslateService } from '@ngx-translate/core';
import { filter, forkJoin, interval, take, timer } from 'rxjs';
import { RouterOutlet } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { IconRegistryService } from '@powerstandards/powerside-ui-lib';

import { NotificationsService } from 'src/app/_shared/modules/notifications/shared/notifications.service';
import { DiligentApiService } from 'src/app/_shared/services/diligent-api.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet],
})
export class AppComponent {
  constructor(
    private translate: TranslateService,
    private swUpdate: SwUpdate,
    private notificationsService: NotificationsService,
    matIconRegistry: MatIconRegistry,
    domSanitizer: DomSanitizer,
    private diligent: DiligentApiService,
    private iconRegistry: IconRegistryService
  ) {
    this.iconRegistry.registerIcon(
      'map-marker-multiple',
      `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="1.8rem" height="1.8rem"><path d="M14,11.5A2.5,2.5 0 0,0 16.5,9A2.5,2.5 0 0,0 14,6.5A2.5,2.5 0 0,0 11.5,9A2.5,2.5 0 0,0 14,11.5M14,2C17.86,2 21,5.13 21,9C21,14.25 14,22 14,22C14,22 7,14.25 7,9A7,7 0 0,1 14,2M5,9C5,13.5 10.08,19.66 11,20.81L10,22C10,22 3,14.25 3,9C3,5.83 5.11,3.15 8,2.29C6.16,3.94 5,6.33 5,9Z" /></svg>`
    );

    this.iconRegistry.registerIcon(
      'dashboard-icon',
      `<svg id="dashboard-icon" fill="currentColor" viewBox="0 0 60 53" width="1.8rem" height="1.8rem"><path d="M 25 43 C 19.89 43 4.95 44.35 1.74 40.57 C -0.31 38.16 0 33.99 0 31 C 0 31 0 10 0 10 C 0.04 7.44 -0.02 4.5 
1.74 2.43 C 4.15 -0.41 8.63 0.01 12 0 C 12 0 44 0 44 0 C 47.65 0 54.78 -0.64 57.57 1.74 C 60.23 4 59.98 7.84 60 11 C 60 11 60 33 60 33 C 59.96 35.94 60.02 39.17 57.57 
41.26 C 54.34 44.01 39.74 43 35 43 C 35 43 35 46 35 46 C 35 46 42 46 42 46 C 42 46 42 52 42 52 C 42 52 18 52 18 52 C 18 52 18 46 18 46 C 18 46 25 46 25 46 C 25 46 25 43 
25 43 Z M 55 5 C 55 5 5 5 5 5 C 5 5 5 38 5 38 C 5 38 55 38 55 38 C 55 38 55 5 55 5 Z M 9 8 C 9 8 35 8 35 8 C 35 8 35 23 35 23 C 35 23 9 23 9 23 C 9 23 9 8 9 8 Z M 37 8 C 
37 8 51 8 51 8 C 51 8 51 16 51 16 C 51 16 37 16 37 16 C 37 16 37 8 37 8 Z M 38 18 C 38 18 51 18 51 18 C 51 18 51 35 51 35 C 51 35 38 35 38 35 C 38 35 38 18 38 18 Z M 22 
25 C 22 25 35 25 35 25 C 35 25 35 35 35 35 C 35 35 22 35 22 35 C 22 35 22 25 22 25 Z M 9 25 C 9 25 20 25 20 25 C 20 25 20 35 20 35 C 20 35 9 35 9 35 C 9 35 9 25 9 25 Z" />
</svg>`
    );

    this.iconRegistry.registerIcon(
      'format-list-bulleted',
      `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="1.8rem" height="1.8rem"><path d="M7,5H21V7H7V5M7,13V11H21V13H7M4,4.5A1.5,1.5 0 0,1 5.5,6A1.5,1.5 0 0,1 4,7.5A1.5,1.5 0 0,1 2.5,6A1.5,1.5 0 0,1 4,4.5M4,10.5A1.5,1.5 0 0,1 5.5,12A1.5,1.5 0 0,1 4,13.5A1.5,1.5 0 0,1 2.5,12A1.5,1.5 0 0,1 4,10.5M7,19V17H21V19H7M4,16.5A1.5,1.5 0 0,1 5.5,18A1.5,1.5 0 0,1 4,19.5A1.5,1.5 0 0,1 2.5,18A1.5,1.5 0 0,1 4,16.5Z" /></svg>`
    );

    this.iconRegistry.registerIcon(
      'hf-emission',
      `<svg id="hf-emission" fill="currentColor" width="1.8rem" height="1.8rem" viewBox="0 0 30 31"><path d="m14 1v29h-2v-29h2zm8-1v31h-2v-31h2zm4 7v17h-2v-17h2zm4 2v13h-2v-13h2zm-20-2v17h-2v-17h2zm8-4v26h-2v-26h2zm-12 1v23h-2v-23h2zm-4 6v11h-2v-11h2z"/></svg>`
    );

    this.iconRegistry.registerIcon(
      'clipboard-check-outline',
      ` <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="1.8rem" height="1.8rem" viewBox="0 0 24 24"><title>clipboard-check-outline</title><path d="M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M7,7H17V5H19V19H5V5H7V7M7.5,13.5L9,12L11,14L15.5,9.5L17,11L11,17L7.5,13.5Z" /></svg>`
    );
    this.iconRegistry.registerIcon(
      'cog',
      `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="1.8rem" height="1.8rem" viewBox="0 0 24 24"><title>cog</title><path d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z" /></svg>`
    );
    this.iconRegistry.registerIcon(
      'filter-remove',
      `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="1.8rem" height="1.8rem" viewBox="0 0 24 24""><title>filter-remove</title><path d="M14.76,20.83L17.6,18L14.76,15.17L16.17,13.76L19,16.57L21.83,13.76L23.24,15.17L20.43,18L23.24,20.83L21.83,22.24L19,19.4L16.17,22.24L14.76,20.83M12,12V19.88C12.04,20.18 11.94,20.5 11.71,20.71C11.32,21.1 10.69,21.1 10.3,20.71L8.29,18.7C8.06,18.47 7.96,18.16 8,17.87V12H7.97L2.21,4.62C1.87,4.19 1.95,3.56 2.38,3.22C2.57,3.08 2.78,3 3,3V3H17V3C17.22,3 17.43,3.08 17.62,3.22C18.05,3.56 18.13,4.19 17.79,4.62L12.03,12H12Z" /></svg>`
    );

    //this.iconRegistry.registerRasterIcon('meter-icon', './assets/images/meter-icon.svg');
    //this.iconRegistry.registerRasterIcon('trends-graph', './assets/images/TrendsGraph_Icon.png');

    matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('./assets/mdi.svg')); // Or whatever path you placed mdi.svg at
    matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('./assets/powerside-icon.svg'));
    matIconRegistry.addSvgIcon('doc-archive', domSanitizer.bypassSecurityTrustResourceUrl('./assets/archive_icon.svg'));
    matIconRegistry.addSvgIcon(
      'pqube',
      domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/PQUBE3_Blue_Icon.svg')
    );
    matIconRegistry.addSvgIcon(
      'psl',
      domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/insite-logo_icon.svg')
    );
    matIconRegistry.addSvgIcon(
      'bad-data',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icon-circle-red.svg')
    );
    matIconRegistry.addSvgIcon(
      'good-data',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icon-circle-green.svg')
    );
    matIconRegistry.addSvgIcon(
      'insufficient-data',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icon-circle-blue.svg')
    );
    matIconRegistry.addSvgIcon(
      'no-data',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icon-circle-white.svg')
    );
    matIconRegistry.addSvgIcon(
      'uncommissioned',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icon-circle-grey.svg')
    );
    matIconRegistry.addSvgIcon(
      'delete-circle-plain',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/delete-circle-plain.svg')
    );
    matIconRegistry.addSvgIcon(
      'firmware-update',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/firmware-update.svg')
    );
    matIconRegistry.addSvgIcon(
      'trend-alert',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/trend-alert-icon.svg')
    );
    matIconRegistry.addSvgIcon(
      'trend-alert-clear',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/trend-alert-clear-icon.svg')
    );
    this.translate.setDefaultLang('en_US');
    this.checkUpdate();
    this.checkMaintenanceMode();
  }

  checkUpdate(): void {
    let dialog;
    if (this.swUpdate.isEnabled) {
      interval(600000).subscribe(async () => {
        const test = await this.swUpdate.checkForUpdate();

        this.swUpdate.versionUpdates
          .pipe(
            filter((evt): any => {
              return evt.type === 'VERSION_READY';
            })
          )
          .subscribe((evt) => {
            if (!dialog) {
              dialog = this.notificationsService
                .alert(this.translate.instant('update.body'), this.translate.instant('update.title'))
                .afterClosed()
                .pipe(take(1))
                .subscribe(() => {
                  document.location.reload();
                });
            }
          });
      });
    }
  }

  checkMaintenanceMode(): void {
    let dialog;
    timer(0, 600000).subscribe(async () => {
      forkJoin([
        this.diligent.getDeploymentMaintenanceFlag(),
        this.diligent.getGlobalMaintenanceFlag(),
        this.diligent.healthOk(),
      ]).subscribe(([isDeploymentInMaintenance, isGlobalMaintenance, healthy]) => {
        let isAppInMaintenance = false;

        if (isGlobalMaintenance) {
          isAppInMaintenance = true;
        } else if (isDeploymentInMaintenance && !healthy) {
          isAppInMaintenance = true;
        }

        const oldValue = localStorage.getItem('isAppInMaintenance') === 'true';
        localStorage.setItem('isAppInMaintenance', isAppInMaintenance.toString());

        if (isAppInMaintenance && !oldValue) {
          if (!dialog) {
            dialog = this.notificationsService
              .alert(this.translate.instant('underMaintenance.body'), this.translate.instant('underMaintenance.title'))
              .afterClosed()
              .pipe(take(1))
              .subscribe(() => {
                document.location.reload();
              });
          }
        } else if (!isAppInMaintenance && oldValue) {
          document.location.reload();
        }
      });
    });
  }
}
